/**
 * Created by Jasmine on 2018/8/2.
 */
const apis = {
    getServerDate: '/v1/invoice-record/server-time',
    //首页相关
    getBusinessStatus: '/v1/index/business-status', //查看商户状态
    getGuide: '/v1/index/guide',//了解电子发票和开通指引
    postLoginWeixin: '/v1/user/scan-login',//微信登录
    bindWechat: '/v1/user/scan-bind',// 绑定微信
    postLoginAccount: '/v1/user/account-login',//账号登录
    postSetPassword: '/v1/user/set-password',//设置商户密码
    getBanner: '/v1/user/get-banner',//获取banner图
    getWXcodeURL: '/v1/user/login-code', //获取登录二维码
    getQrcodeConfig: '/v1/user/qrcode-config',//获取登录二维码的配置信息
    getMenuList: '/v1/authorization/new-list', // 获取用户菜单列表
    getUnauditNum: '/v1/invoice-record/red-count', // 获取小程序开票待审核数量
    getCaptcha: '/v1/user/picture-code', // 获取图形验证码
    getUpdateInfo: '/v1/client/update-info', // 系统升级说明（当前版本）
    getUpdateLogs: '/v1/client/update-log-list', // 系统升级日志列表（所有版本）

    //我的订单
    postClientOrder: '/v1/client-order/index',//获取商户订单
    postCancelClientOrder: '/v1/client-order/cancel-order',//取消商户订单
    postClientOrderDetail: '/v1/client-order/order-detail',//获取商户订单详情
    postPayInfo: '/v1/client-order/get-pay-qrcode',//获取订单支付信息
    getDiscountPackages: '/v1/client-order/renew-scheme-list', // 获取续费套餐列表
    createPackageOrder: '/v1/client-order/order-create', // 创建续费订单
    postInvoiceOrderCreate: '/v1/client-order/invoice-order-create',//申请开票
    postInvoiceRetry: '/v1/invoice-record/blue-retry',//重试开票
    postBlueRetryOne: '/v1/invoice-record/blue-retry-one',//重试开票（新）
    getChengduDxhRefresh: '/v2/rpr/refresh-invoice-status',//成都点下户刷新开票状态
    postRegisterCode: '/v1/client-order/code-order-create', // 注册码续费
    getPhoneCode: '/v2/system/send-message', // 订单-获取手机号验证码
    postPhone: '/v2/system/replenish-mobile', // 完善账户手机信息


    //开票审核
    postReject: '/v1/invoice-record/reject',                // 拒绝开票
    postPass: '/v1/invoice-record/confirm',                 // 确认开票
    getGoodsClass: '/v1/invoice-record/get-project',        // 税目类别信息
    getBillingRecords: '/v1/invoice-record/list',           // 获取用户开票记录列表
    getOrderInfo: '/v1/invoice-record/info',                // 获取发票订单详情
    postConfirmList: '/v1/invoice-record/batch-confirm',     // 批量确认开票
    getClientInfo: '/v1/invoice-record/get-client-info',     // 获取当前商户信息
    invoiceRetry: '/v1/invoice-record/blue-retry',           // 重新开票(蓝票)
    haidingInvoiceRetry: '/v1/detail-record/retry-get-order', // 海鼎商户重试开票
    getInvoiceTypes: '/v1/invoice-record/paper-qualification-list', // 发票类型
    sendPdf: '/v1/detail-record/send-mail', // 发送PDF到邮箱
    getHelperStatus: '/v1/invoice-record/helper-status', // 获取发票助手状态
    getPluginStatus: '/v1/invoice-record/plugin-status', // 税盘在线状态、余票查询
    setBatchReject: '/v1/invoice-record/batch-reject',       // 批量拒绝开票

    // 商户注册
    verifyTax: '/v1/register/taxation',                     // 验证纳税人识别号
    getPictureCode: '/v1/register/picture-code',            // 获取图片验证码
    getMobileCode: '/v1/register/mobile-code',              // 获取短信验证码
    fillUserInfo: '/v1/register/replenish',                 // 新用户完善账户信息
    selectScheme: '/v2/client/select-scheme',               // 选择套餐
    SchemeList: '/v1/client/scheme-list',                   // 套餐列表
    getTitle: '/small/title/get-title',                     // 模糊查寻
    fillCompanyInfo: '/v2/client/create-info',               // 新用户完善企业信息
    getIndustryList: '/v1/client/industry-list',             // 行业列表
    setStockPw: '/v1/register/supplement',                   // 存量用户完善登录信息
    getUserInfo: '/v2/client/info',                          // 获取用户对应信息

    // 系统设置
    getSystemView: '/v2/system/view',                        // 系统设置 获取详情
    setLogo: '/v1/system/set-logo',                          // 上传logo
    setDefaultProject: '/v1/system/default-project',         // 设置默认开票项目
    setOther: '/v1/system/set-other',                        // 其他设置
    setQuota: '/v2/system/set-quota',                        // 设置开票限额
    fpCheck: '/v1/detection/synchronous',                    // 发票查验
    resetPassword: '/v1/user/reset-password',                // 商户重置密码（登陆后设置）
    clientBoxStatus: '/v1/client/box-status',                // 发票盒子
    isRedWarn: 'v1/system/red-point',                        // 对没有配置预警库存或者邮箱的商户，红点提示
    getSysShops: '/v2/system/store-list',                     // 获取系统设置门店列表
    sysMobileCode: '/v2/system/send-message',                 // 获取短信验证码
    editSysInfo: '/v2/system/edit-account-info',              // 修改账户信息
    bindQrcode: '/v2/system/bind-qr-code',                    // 获取绑定的二维码
    unbindWechat: '/v1/subacc/remv-bind',                     // 解除绑定
    getCompanyInfo: '/v2/system/enterprise-info',             // 查看企业信息
    fetchIndustryList: '/v1/client/industry-list',            // 行业列表数据
    bindGroups: '/v2/system/bind-jt-client',                  // 集团帐号绑定
    appAuthList: '/v2/system/app-auth-list',                  // 应用授权查询
    appAuthDetail: '/v2/system/app-auth-detail',              //应用授权精准查询
    appAuthBind: '/v2/system/app-auth-bind',                  // 应用授权绑定
    appAuthUnbind: '/v2/system/app-auth-unbind',              // 应用授权解绑
    getRealnameInfo: '/v2/rpr/check-real-name',               // 检测是否法人实名认证
    postRealnameInfo: '/v2/rpr/modify-legal-person',          // 法人实名认证

    // 开票汇总
    postInvoiceMonthy: '/v1/statistics/invoice-monthy',      // 开票月度汇总
    postInvoiceExport: '/v1/statistics/invoice-export',      // 开票月度汇总下载

    // 开票明细 by tangtang
    postListRecord: '/v1/detail-record/list',                 // 开票列表
    getDetailRecord: '/v1/detail-record/info',                // 开票详情
    postRedRecord: '/v1/detail-record/red',                   // 冲红
    postOutList: '/v1/detail-record/out-list',                // 导出
    getStores: '/v1/detail-record/store-subcount',            // 获取商户的门店列表，子账号列表
    printPaperInvoice: '/v1/detail-record/print-paper-invoice', // 打印纸票
    sendMail: '/v1/detail-record/send-mail',   //发送邮件

    //找回密码
    postRegisterRetrieve: 'v1/register/retrieve',             // 找回密码

    // 商品编码
    getCodeList: '/v1/client-project/projects',               // 查询商户的税收商品
    getTaxRate: '/v1/client-project/tax-rate',                // 获取商品税率
    getDefaultProject: '/v1/client-project/default-project',  // 获取默认设置项目
    deleteProject: '/v1/client-project/delete',               // 删除商品编码
    createProject: '/v1/client-project/create',               // 新增商品编码
    editProject: '/v1/client-project/edit',                   // 修改商品编码
    searchProject: '/v1/client-project/search',               // 查询税收商品
    uploadExcel: '/v1/client-project/upload-excel',            // 商品编码文件上传
    uploadRecord: '/v1/client-project/export-record',          // 商品编码编码导入记录
    downloadExcel: '/v1/client-project/download-export-record', // 商品编码下载编码导入结果
    getGoodsNames: '/v1/client-project/match-commodity-name', // 获取企业商品名称列表

    //账号管理
    postSubaccList: 'v1/subacc/list',                          //子账号列表
    postCreateSubacc: 'v1/subacc/create',                      //新增子账号
    //post:'v1/subacc/store-list',                          //门店列表
    postDrawerList: 'v1/subacc/drawer-list',             //开票员列表
    postSubaccInfo: 'v1/subacc/info',                              //子账号详情
    postSubaccUpdate: 'v1/subacc/update',                //子账号编辑（修改）
    postSubaccDelete: 'v1/subacc/delete',                 //子账号删除
    getPwd: 'v1/subacc/gen-pwd',//生成随机密码

    // 门店管理
    getShopList: '/v1/store/list-store',                        // 门店列表
    addShop: '/v1/store/add-store',                            // 新增门店
    editShop: '/v1/store/edit-store',                          // 修改门店
    downloadQrcode: '/v1/store/pack-download-qrcode',          // 批量下载开票二维码
    getAreaSearch: '/areas/area-search',                       //获取多级省区信息
    getChengduAreaSearch: '/areas/cd-area-search',             //获取多级省区信息
    getTaxPullList:'/v1/store/tax-list',                       //下拉税盘列表
    setStoreQrcode: '/v1/store/set-store-qrcode',              //停止二维码使用
    setStoreDel:'/v1/store/del',                                //删除门店

    // 人工开票
    getGoodsList: '/v1/online-invoicing/client-projects',     // 获取商户商品列表
    getMerchantInfo: '/v1/online-invoicing/client-info',      // 获取开票方信息
    submitInvoice: '/v1/online-invoicing/blue',                // 提交开蓝票
    countInvoice: '/v1/online-invoicing/tax-handle',           // 计算开票行税额、金额、折扣等数据

    postEnterpriseEdit: '/v2/system/enterprise-edit',             //修改企业信息
    checkEnterprise: '/v2/system/check-enterprise-info',   // 检测企业信息是否完整
    checkTicketSum: '/v2/system/remain-sum',               // 检查票量情况
    checkBoxOffline: '/v2/system/off-line',                // 检查盒子离线情况

    getCodeOrderList: '/v1/code-order/list',                //小票列表
    addInvoice: '/v1/code-order/create',                      // 新增小票
    smallInvoiceDetail: '/v1/code-order/info',                      // 小票详情
    smallInvoiceDelete: 'v1/code-order/delete',                      // 小票软删除
    invoiceBlueRetryOne: 'v1/invoice-record/blue-retry-one',                      // 发票单张重试开票

    postVersionNotice: '/v1/client/version-notice',          //获取版本更新通知
    codeOrderExport: '/v1/code-order/export',                //列表导出
    subaccLists:'/v1/subacc/lists',                         //获取子账户列表
    addInvalid: '/v1/code-order/invalid',                    //小票作废

    // 体验
    getPrintList: '/v1/code-order/print-list',                  // 获取打印小票列表
    printed: '/v1/code-order/batch-printed',                 // 小票批量设为已打印

    // 税盘管理
    getMachines: 'v1/store/sub-machines', // 税盘分机号列表
    createOrder: 'v1/store/order-create', // 创建订单并生成支付二维码
    postTaxnumEdit: 'v1/tax-num/edit',//修改税盘
    postPlateInfo: 'v1/tax-num/info',//修改税盘信息
    postTaxNumList: '/v1/tax-num/list',//1.航天金税盘=》获取航信分机号列表; 2.百望税控盘=》获取百望税盘列表

    pluginPrint: '/v1/code-order/baiwang-print', //插件打印

    getTaxManageList: '/v2/tax/list',   //税盘列表
    taxCreate: '/v2/tax/create',   //税盘新增
    taxUpdate: '/v2/tax/update',   //税盘修改
    getTaxInfo: '/v2/tax/info',   //税盘详情
    taxDel: '/v2/tax/del',       //税盘删除
    getClientInvoiceType:'/v2/tax/client-invoice-type',   //获取默认开票项


    // 酒店开票
    getHotelInfo: '/v1/invoice-record/info-hotel', // 开票请求-详情
    submitHotelInvoice: '/v1/hotel/hotel-blue', // 酒店开票审核

    // 学习中心
    studyVideos: '/v2/study/video', // 视频列表
    resourceDownloads: '/v2/study/download', // 资源下载列表
    reportPlayVideo: '/v2/study/upload-video-record', // 视频播放上报
    reportDownloadResource: '/v2/study/upload-download-record', // 资源下载上报

    // 分税率统计
    taxCountList: '/v1/statistics/rate', // 获取分税率统计列表
    taxExport: '/v1/statistics/rate-export', // 分税率统计导出

    // 纸票管理
    paperInvoiceAndPrint: '/v1/paper/invoiceAndPrint', // 开票并打印，支持在线人工开票，二维码小票开票
    paperInvoiceList: '/v1/paper/list', // 发票列表
    paperInvoiceDetail: '/v1/paper/detail', // 发票详情
    paperPrint: '/v1/paper/print', // 纸票打印
    paperRetry: '/v1/paper/try', // 重试开票
    paperReject: '/v1/paper/reject', // 拒绝开票
    paperInvoice: '/v1/paper/invoice-and-print', // 开票并打印
    paperGetInvoiceCode: '/v1/paper/get-invoice-style-code', // 待审核的发票，获取下一张纸票的发票代码和号码，用于页面显示
    invoiceInvalid: '/v1/detail-record/invalid', // 作废

    // 支付开票
    submitCollectionInfo: '/v2/orders/apply',    //申请开通权限
    getOrdersStatus: 'v2/orders/status',   //申请状态
    getCollectionList: 'v2/orders/list',   //获取订单列表
    getOrdersStoreList: 'v2/orders/store-list',  //获取过滤用的门店列表
    getinvoiceQRcode: 'v2/orders/generate-invoice-qr-code', //列表中操作 开具发票 拉取二维码
    getDownloadQRcode: 'v2/orders/qrcode-download',  //下载二维码
    getOrdersReSubmit: 'v2/orders/re-submit',  //开票重试
    uploadImage: '/v2/orders/upload-image', // 上传图片
    getBankList: '/v2/orders/bank-list', // 获取银行列表
    completeIndustrys: '/v2/orders/industry-list', // 获取行业列表
    searchBankBranch: '/v2/orders/bank-search', // 模糊匹配银行支行
    getCollectionInfo: '/v2/orders/apply-view', // 获取提交过的申请数据
    submitBill: '/v2/orders/check-download-submit', // 生成账单
    getBillList: '/v2/orders/check-download-list', // 获取账单列表
    getReceiptQrcode: '/v2/orders/qrcode', // 获取收款码
    downReceiptQrcode: '/v2/orders/qrcode-download', // 获取收款码
    getOrdersSetting: '/v2/orders/settings', // 开票入口控制，读取
    postOrdersExport: '/v2/orders/orders-export',  //支付订单导出的接口
    ordersPayTicketGuide: '/v2/orders/pay-ticket-guide', //获取支付开票指导PDF
    ordersInviteTicket: '/v2/orders/invite-ticket', // 邀请开票

    // 批量开票
    downloadBatExport: '/v2/client/download-bat-export',  //下载批量开具发票模板
    batExportRecord: '/v2/client/bat-export-record',  //批量开票excel导入记录
    batRecord: '/v2/client/bat-record',     //批量开票记录
    uploadBatInvoiceExcel: '/v2/client/upload-bat-invoice-excel',  //批量开票excel数据上传
    batInvoice: '/v2/client/bat-invoice',  //批量发起开票
    downloadBatExportRecord: '/v2/client/download-bat-export-record',  //批量开票下载导入记录
    downloadBatFailRecord: '/v2/client/download-bat-fail-record',  //下载开票失败记录
    getTaxList: '/v1/tax-num/tax-list',   //获取当前商户的税盘列表
    getBatTimes: '/v2/client/bat-times',   //获取批开次数

    // 版本升级
    getMemberSchemeList:'/v1/client/member-scheme-list', //获取会员权限详情
    getMemberSelectScheme:'/v1/client/member-select-scheme',//获取支付订单二维码
    memberSchemeSucc:'v1/client/member-scheme-succ', //完成支付

    // 强制弹出窗
    setSubaccBindMobile: '/v1/subacc/subacc-bind-mobile',  //强制添加子账号手机号

    // 智慧酒店
    getOrderDetail: '/v1/hotel/get-order-detail',   //获取商户水单详情
    getOrderPage: '/v1/hotel/get-order-page',  //获取商户水单分页数据

    // 通用智慧酒店
    commonGetOrderPage: '/v1/hotel/get-order-page-common', //获取商户水单分页数据
    infoHotelCommon: '/v1/invoice-record/info-hotel-common', //开票请求-酒店通用
    hotelBlueCommon: '/v1/hotel/hotel-blue-common', //开票请求-酒店通用

    // 合同
    getContract: '/v2/client/get-contract', // 获取合同
    signContract: '/v2/client/sign-contract', // 签署合同
    getContractList: '/v2/client/contract-list', // 合同列表
};

export default apis
